import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { FaChevronLeft } from 'react-icons/fa';

import './style.scss';

function Header({ image, onBackButtonClick }: {image?: { src: string, alt: string}, onBackButtonClick?: Function}) {

  const backButtonClickHandler = (e: any) => {
    e.preventDefault();
    onBackButtonClick && onBackButtonClick();
  };

  return (
    <header className="AppHeader">
      <Navbar expand="lg">
      <Container>
        { onBackButtonClick && <Navbar.Brand id="basic-navbar-nav">
          <button onClick={backButtonClickHandler} className="btn-go-back">
            <FaChevronLeft color="#FFFFFF" size={32} />
          </button>
        </Navbar.Brand>}
      </Container>
      <Container className="justify-content-center">
        {image &&
          (<Navbar.Brand>
            <img
              alt={image.alt}
              className="d-inline-block align-top"
              height="50px"
              src={image.src}
            />
          </Navbar.Brand>)
        }
      </Container>
      <Container>

      </Container>
      </Navbar>
    </header>
  );
}

export default Header;
